import { ICreateReajusteContratoIndividualUseCase } from "../../../presentation/useCases/create/create_reajuste_contrato_individual_use_case";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * CreateReajusteContratoIndividualUseCase
 */

export class CreateReajusteContratoIndividualUseCase implements ICreateReajusteContratoIndividualUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async execute(
    idContratoFinanceiro: number,
    idIndiceReajuste: number,
    aplicarNaEntrada: boolean,
    dataInicioAplicacaoReajuste?: Date,
    dataReajusteDe?: Date,
    dataReajusteAte?: Date,
  ): Promise<void> {

    await this.repository.createReajusteContratoIndividual(
      idContratoFinanceiro,
      idIndiceReajuste,
      aplicarNaEntrada,
      dataInicioAplicacaoReajuste,
      dataReajusteDe,
      dataReajusteAte
    );
  }
}
